import React from "react";
import StimulusDialog from "../components/modals/StimulusDialog";

export default function (props) {
  return <StimulusDialog />;
}
